// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"114":"core","121":"vendor","123":"icons","209":"ui","781":"tutorial"}[chunkId] || chunkId) + "-" + {"114":"5266c7e0","121":"d51ff4fa","123":"86765a73","188":"0df73324","209":"aac9c20c","412":"6666383c","781":"b1df584b","933":"5db1663a"}[chunkId] + ".js";
};